import Vue from 'vue'
import VueRouter from 'vue-router'
import index from '@/views/index'//首页
import newslist from "@/views/news/index"//新闻中心列表页
import newsdetail from "@/views/news/detail"//新闻中心详情页面
import noticedetail from "@/views/notice/detail"//公告详情

import portal from "@/views/luntan/index/index"//首页
import forum from "@/views/luntan/luntan/index"//论坛
import boke from "@/views/luntan/boke/index"//博客
import forumdisplay from "@/views/luntan/luntan/forumdisplay"//帖子列表
import forumdetail from "@/views/luntan/luntan/detail"//帖子详情
import bokedetail from "@/views/luntan/boke/detail"//博客详情
import newthread from "@/views/luntan/luntan/newthread"//最新发表等
import taboke from "@/views/luntan/boke/taboke"//TA的博客
import neirong from "@/views/luntan/neirong/index"//内容管理
import search from "@/views/luntan/search"//搜索
import hj01 from "@/views/huanjing/hj01/index"//公开参观环境
import hj02 from "@/views/huanjing/hj02/index"//技术验证环境
import hj03 from "@/views/huanjing/hj03/index"//共享开发环境
import hj04 from "@/views/huanjing/hj04/index"//专项开发环境
import gongxiangsave from "@/views/huanjing/save/gongxiangsave"//共享环境加入
import hdbaoming from "@/views/news/baoming"//活动报名
import huanjinglist from "@/views/huanjing/list"//环境列表
Vue.use(VueRouter)

const routes = [
	//门户部分
	{
	  path: '/',
	  name: 'index',
	  component:index,
	  meta: {
		title: '门户首页',
		type:1
	  }
	},
	{
		path:'/newslist',
		name:"newslist",
		component:newslist,
		meta: {
		  title: '新闻列表',
		  type:1
		}
	},
	{
		path:"/newsdetail",
		name:"newsdetail",
		component:newsdetail,
		meta: {
		  title: '详情',
		  type:1
		}
	},
	{
		path:"/noticedetail",
		name:"noticedetail",
		component:noticedetail,
		meta: {
		  title: '公告详情',
		  type:1
		}
	},
	{
		path:"/hj01",
		name:"hj01",
		component:hj01,
		meta: {
		  title: '公开参观环境',
		  type:1
		}
	},
	{
		path:"/hj02",
		name:"hj02",
		component:hj02,
		meta: {
		  title: '技术验证环境',
		  type:1
		}
	},
	{
		path:"/hj03",
		name:"hj03",
		component:hj03,
		meta: {
		  title: '共享开发环境',
		  type:1
		}
	},
	{
		path:"/hj04",
		name:"hj04",
		component:hj04,
		meta: {
		  title: '专享开发环境',
		  type:1
		}
	},
	{
		path:"/gongxiangsave",
		name:"gongxiangsave",
		component:gongxiangsave,
		meta: {
		  title: '申请加入共享开发环境',
		  type:1
		}
	},
	{
		path:"/hdbaoming",
		name:"hdbaoming",
		component:hdbaoming,
		meta: {
		  title: '活动报名',
		  type:1
		}
	},
	{
		path:"/huanjinglist",
		name:"huanjinglist",
		component:huanjinglist,
		meta: {
		  title: '列表',
		  type:1
		}
	},
	//论坛博客部分
	{
		path:"/taboke",
		name:"taboke",
		component:taboke,
		meta: {
		  title: 'TA的博客',
		  type:2
		}
	},
	{
		path:"/portal",
		name:"portal",
		component:portal,
		meta:{
			title:"首页",
			type:2
		}
	},
	{
		path:"/forum",
		name:"forum",
		component:forum,
		meta:{
			title:"论坛",
			type:2
		}
	},
	{
		path:"/boke",
		name:"boke",
		component:boke,
		meta:{
			title:"博客",
			type:2
		}
	},
	{
		path:"/forumdisplay",
		name:"forumdisplay",
		component:forumdisplay,
		meta:{
			title:"论坛列表",
			type:2
		}
	},
	{
		path:"/forumdetail",
		name:"forumdetail",
		component:forumdetail,
		meta:{
			title:"帖子详情",
			type:2
		}
	},
	{
		path:"/newthread",
		name:"newthread",
		component:newthread,
		meta:{
			title:"导读",
			type:2
		}
	},
	{
		path:"/bokedetail",
		name:"bokedetail",
		component:bokedetail,
		meta:{
			title:"博客详情",
			type:2
		}
	},
	{
		path:"/neirong",
		name:"neirong",
		component:neirong,
		meta:{
			title:"管理中心",
			type:2
		}
	},
	{
		path:"/search",
		name:"search",
		component:search,
		meta:{
			title:"搜索",
			type:2
		}
	}
];
const router = new VueRouter({
	routes
})
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js